import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getOrgMembers,
  OrgMemberWithProfileAndProjectAccess,
} from '@/features/org/api/get-org-members';
import { useCanManageOrgMembers } from '@/features/org/hooks/use-can-manage-org-members';
import { useCurrentOrg } from '@/features/org/hooks/use-org';

type Props = UseQueryOptions<
  OrgMemberWithProfileAndProjectAccess[],
  unknown,
  OrgMemberWithProfileAndProjectAccess[]
>;

export const getOrgMembersQueryKey = (orgId?: string) => [
  'orgMembers',
  ...(orgId ? [orgId] : []),
];

export const useOrgMembersQuery = (props?: Props) => {
  const canManageOrgMembers = useCanManageOrgMembers();
  const { data: org, isLoading: isOrgLoading } = useCurrentOrg();

  return useQuery({
    ...props,
    queryKey: getOrgMembersQueryKey(org?.id.toString()),
    queryFn: () => {
      if (isOrgLoading || !org) {
        return [];
      }

      return getOrgMembers({ orgId: org.id });
    },
    enabled: canManageOrgMembers,
  });
};
